// Network tab under SiteLayout — site router, firewall + switch editors. The site's
// PageHeader/tabs come from SiteLayout (like the Devices/Areas panels), so this
// composes section headings only. Endpoints are site_slug-scoped; accountSlug is
// only needed for the firewall VLAN-name selectors (allocation ledger query).

import { useIsPlatformAdmin } from "../auth/useIsPlatformAdmin";
import { RouterEditor } from "./RouterEditor";
import { FirewallPolicyEditor } from "./FirewallPolicyEditor";
import { FirewallRulesTable } from "./FirewallRulesTable";
import { SwitchesSection } from "./SwitchesSection";

export function SiteNetworkPanel({
  accountSlug,
  siteSlug,
}: {
  accountSlug: string;
  siteSlug: string;
}) {
  const canWrite = useIsPlatformAdmin();
  return (
    <div style={{ display: "grid", gap: 28 }}>
      <section style={{ display: "grid", gap: 12 }}>
        <h3 style={sectionH}>Router</h3>
        <RouterEditor siteSlug={siteSlug} canWrite={canWrite} />
      </section>
      <section style={{ display: "grid", gap: 12 }}>
        <h3 style={sectionH}>Firewall policy</h3>
        <FirewallPolicyEditor accountSlug={accountSlug} siteSlug={siteSlug} canWrite={canWrite} />
      </section>
      <section>
        <FirewallRulesTable accountSlug={accountSlug} siteSlug={siteSlug} canWrite={canWrite} />
      </section>
      <section>
        {/* Switches use the template-catalog VLANs (not the account ledger) → siteSlug only. */}
        <SwitchesSection siteSlug={siteSlug} canWrite={canWrite} />
      </section>
    </div>
  );
}

const sectionH: React.CSSProperties = { margin: 0, fontSize: "0.95rem" };
